module.exports = __webpack_public_path__ + "img/main_01.128cbe15.png";